import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';

import { ENVIRONMENT_CONFIG, EnvironmentConfig } from '@shared/config';
import { dismissLocaleSetupBanner, shouldShowLocaleSetupBanner, switchToLocale } from '@shared/i18n';

/**
 * Prompts English-bundle users on CA apps to switch to French.
 * Visibility of `.locale-setup-banner` drives `--locale-banner-height` via `:root:has(...)`.
 */
@Component({
  selector: 'pulse-locale-setup-banner',
  templateUrl: './pulse-locale-setup-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PulseLocaleSetupBannerComponent {
  private envConfig = inject<EnvironmentConfig>(ENVIRONMENT_CONFIG);

  visible = signal(shouldShowLocaleSetupBanner(!!this.envConfig.localeSwitchEnabled));

  onSwitchToFrench(): void {
    dismissLocaleSetupBanner();
    this.visible.set(false);
    switchToLocale('fr-CA');
  }

  onDismiss(): void {
    dismissLocaleSetupBanner();
    this.visible.set(false);
  }
}
